import React, { useContext, ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';
import AuthContext from '@packages/contexts/auth/authContext';

import { Role } from '../../../types/Auth';
import { CLIENT_STATUS } from '../../../types/Client';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import ClientForm from '../ClientForm';
import { submitSmartFleetChoiceConfigFactory } from '../utils/submit';
import SmartFleetChoiceSection from '../../../components/Feature/SmartFleetChoiceSection';

const SmartFleetChoiceForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, resetFormFlag, setData } = useClientFormContext();
    const { user } = useContext(AuthContext);

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        const smartFleetChoice = await submitSmartFleetChoiceConfigFactory(client.id, data.smartFleetChoice)(form);
        setData({ ...data, smartFleetChoice });
    };

    const renderSmartFleetChoiceComponent = (form: FormInstance): JSX.Element | null => {
        if (!user || (user.role !== Role.StuartStaff && user.role !== Role.SE)) {
            return <span>You need another role to be able to edit this page.</span>;
        }
        return (
            <SmartFleetChoiceSection
                formInstance={form}
                smartFleetChoiceConfig={data.smartFleetChoice}
                isDetailMode={formConfig.isDetailMode}
                resetFormFlag={resetFormFlag}
                enableControls={client?.status !== CLIENT_STATUS.DELETED}
            />
        );
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="smart-fleet-choice" submitForm={submitForm}>
                        {({ form }): ReactElement | null => renderSmartFleetChoiceComponent(form)}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default SmartFleetChoiceForm;
